export const canaryCss = `
  .ep{background:#14110a;display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh;padding:2rem 1rem;position:relative;overflow:hidden;gap:1rem}
  .bw{width:180px;height:180px;transform-origin:bottom center;animation:wf 2.3s 0.6s forwards;flex-shrink:0}
  @keyframes wf{
    0%{transform:rotate(0deg);animation-timing-function:ease-in-out}
    9%{transform:rotate(-6deg);animation-timing-function:ease-in-out}
    19%{transform:rotate(7deg);animation-timing-function:ease-in-out}
    28%{transform:rotate(-5deg);animation-timing-function:ease-in-out}
    37%{transform:rotate(5deg);animation-timing-function:ease-in-out}
    44%{transform:rotate(-2deg);animation-timing-function:ease-in-out}
    51%{transform:rotate(0deg);animation-timing-function:ease-in}
    100%{transform:rotate(87deg)}
  }
  .star{position:absolute;color:#3a8c80;font-size:15px;opacity:0;animation:fs 2.2s ease-out infinite;pointer-events:none;z-index:2}
  .s1{left:60%;top:46%;animation-delay:3.1s}
  .s2{left:71%;top:37%;animation-delay:3.5s}
  .s3{left:53%;top:55%;animation-delay:3.8s}
  .s4{left:66%;top:58%;animation-delay:3.3s}
  @keyframes fs{0%{opacity:0;transform:translateY(0) scale(.8)}25%{opacity:1}80%{opacity:.6}100%{opacity:0;transform:translateY(-30px) scale(1.1)}}
  .ht{font-family:'Cormorant Garamond',Georgia,serif;font-size:2rem;font-weight:600;color:#c4983a;margin:0;letter-spacing:.02em;text-align:center}
  .sub{font-family:'DM Mono','Courier New',monospace;font-size:.72rem;color:#f0ead8;opacity:.55;margin:0;letter-spacing:.08em;text-align:center}
  .btn{font-family:'DM Mono','Courier New',monospace;font-size:.72rem;letter-spacing:.1em;padding:.55rem 1.4rem;background:transparent;border:1px solid #c4983a;color:#c4983a;cursor:pointer;transition:background .15s,color .15s;text-transform:uppercase;margin-top:.3rem}
  .btn:hover{background:#c4983a;color:#14110a}
`;
export const CanaryAnimation = () => {
  return (
    <>
      <style>{canaryCss}</style>
      <span className="star s1">✦</span>
      <span className="star s2">✦</span>
      <span className="star s3">✦</span>
      <span className="star s4">✦</span>
      <div className="bw">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 511.978 511.978"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              style={{ fill: '#f0ead8' }}
              d="M165.317,277.332h-74.31c-5.891,0-10.672-4.781-10.672-10.672c0-5.89,4.781-10.671,10.672-10.671h74.31c5.89,0,10.663,4.781,10.663,10.671C175.98,272.551,171.207,277.332,165.317,277.332z"
            />
            <path
              style={{ fill: '#f0ead8' }}
              d="M165.669,405.326H91.008c-5.891,0-10.672-4.78-10.672-10.671s4.781-10.672,10.672-10.672h74.661c5.89,0,10.663,4.781,10.663,10.672S171.558,405.326,165.669,405.326z"
            />
            <path
              style={{ fill: '#f0ead8' }}
              d="M165.325,458.653c-5.891,0-10.672-4.766-10.672-10.672V213.327c0-20.96,4.797-42.382,14.257-63.662c7.445-16.757,17.789-33.467,30.749-49.662c21.93-27.404,43.678-43.85,44.592-44.537c4.711-3.53,11.398-2.578,14.938,2.133c3.531,4.719,2.578,11.398-2.133,14.938c-0.203,0.148-20.819,15.78-41.068,41.209c-33.062,41.498-39.999,77.06-39.999,99.582v234.654C175.988,453.887,171.215,458.653,165.325,458.653z"
            />
            <path
              style={{ fill: '#f0ead8' }}
              d="M335.981,458.653c-5.89,0-10.655-4.766-10.655-10.672V213.327c0-79.083-80.263-140.182-81.075-140.791c-4.711-3.539-5.664-10.219-2.133-14.938c3.531-4.711,10.219-5.663,14.938-2.133c0.914,0.688,22.663,17.133,44.585,44.537c12.968,16.195,23.311,32.905,30.747,49.662c9.469,21.28,14.25,42.702,14.25,63.662V447.98C346.637,453.887,341.872,458.653,335.981,458.653z"
            />
          </g>
          <path
            style={{ fill: '#1e1810' }}
            d="M250.649,74.669c-17.64,0-31.998-14.359-31.998-31.999c0-17.648,14.358-31.999,31.998-31.999c17.647,0,31.991,14.351,31.991,31.999C282.64,60.309,268.297,74.669,250.649,74.669z M250.649,31.998c-5.875,0-10.664,4.789-10.664,10.672s4.789,10.663,10.664,10.663c5.883,0,10.672-4.78,10.672-10.663S256.532,31.998,250.649,31.998z"
          />
          <g>
            <path
              style={{ fill: '#f0ead8' }}
              d="M410.635,495.978H90.656c-5.891,0-10.664-4.781-10.664-10.655V223.99c0-45.584,17.749-88.434,49.982-120.667c32.233-32.24,75.091-49.99,120.675-49.99c45.585,0,88.441,17.75,120.675,49.99c32.233,32.233,49.999,75.083,49.999,120.667v261.333C421.323,491.197,416.542,495.978,410.635,495.978z M101.327,474.651h298.652V223.99c0-39.881-15.531-77.38-43.748-105.59c-28.186-28.202-65.684-43.731-105.582-43.731c-39.881,0-77.38,15.529-105.589,43.731c-28.202,28.21-43.733,65.709-43.733,105.59L101.327,474.651L101.327,474.651z"
            />
            <path
              style={{ fill: '#f0ead8' }}
              d="M250.649,458.653c-5.891,0-10.664-4.766-10.664-10.672V63.997c0-5.891,4.773-10.664,10.664-10.664c5.891,0,10.672,4.773,10.672,10.664v383.984C261.321,453.887,256.54,458.653,250.649,458.653z"
            />
          </g>
          <path
            style={{ fill: '#c4983a' }}
            d="M430.494,26.677l-35.858-7.765c-2.938-0.641-6.031,0-8.469,1.758l-68.121,48.889c-2.469,1.781-4.078,4.531-4.391,7.57c-0.312,3.03,0.688,6.054,2.734,8.304c1.25,1.352,30.811,33.186,63.497,33.186c5.562,0,10.968-0.922,16.062-2.733c16.484-5.867,29.156-21.617,36.64-45.537c5.266-16.789,6.266-31.937,6.297-32.577C439.213,32.513,435.65,27.795,430.494,26.677z"
          />
          <path
            style={{ fill: '#3a8c80' }}
            d="M299.265,106.667c-3.344,0-6.625-1.562-8.719-4.492c-3.406-4.797-2.281-11.461,2.531-14.866l90.058-63.997c4.797-3.414,11.469-2.289,14.875,2.515c3.406,4.797,2.281,11.461-2.531,14.867l-90.058,63.997C303.547,106.026,301.39,106.667,299.265,106.667z"
          />
          <path
            style={{ fill: '#1e1810' }}
            d="M442.634,42.67h-10.655c-5.891,0-10.655-4.773-10.655-10.672c0-5.891,4.765-10.663,10.655-10.663h10.655c5.906,0,10.688,4.772,10.688,10.663C453.321,37.896,448.54,42.67,442.634,42.67z"
          />
          <path
            style={{ fill: '#3a8c80' }}
            d="M431.978,447.981H69.329c-5.891,0-10.672,4.781-10.672,10.672v42.669c0,5.875,4.781,10.656,10.672,10.656h362.649c5.891,0,10.655-4.781,10.655-10.656v-42.669C442.634,452.762,437.869,447.981,431.978,447.981z"
          />
          <g>
            <path
              style={{ fill: '#256059' }}
              d="M335.981,490.65c-5.89,0-10.655,4.766-10.655,10.672v10.656h21.312v-10.656C346.637,495.416,341.872,490.65,335.981,490.65z"
            />
            <path
              style={{ fill: '#256059' }}
              d="M293.328,490.65c-5.906,0-10.688,4.766-10.688,10.672v10.656h21.344v-10.656C303.984,495.416,299.203,490.65,293.328,490.65z"
            />
            <path
              style={{ fill: '#256059' }}
              d="M250.649,490.65c-5.891,0-10.664,4.766-10.664,10.672v10.656h21.336v-10.656C261.321,495.416,256.54,490.65,250.649,490.65z"
            />
            <path
              style={{ fill: '#256059' }}
              d="M207.987,490.65c-5.891,0-10.664,4.766-10.664,10.672v10.656h21.328v-10.656C218.651,495.416,213.878,490.65,207.987,490.65z"
            />
            <path
              style={{ fill: '#256059' }}
              d="M165.325,490.65c-5.891,0-10.672,4.766-10.672,10.672v10.656h21.335v-10.656C175.988,495.416,171.215,490.65,165.325,490.65z"
            />
            <path
              style={{ fill: '#256059' }}
              d="M122.654,490.65c-5.89,0-10.663,4.766-10.663,10.672v10.656h21.335v-10.656C133.326,495.416,128.545,490.65,122.654,490.65z"
            />
            <path
              style={{ fill: '#256059' }}
              d="M378.636,490.65c-5.875,0-10.656,4.766-10.656,10.672v10.656h21.343v-10.656C389.323,495.416,384.542,490.65,378.636,490.65z"
            />
          </g>
          <path
            style={{ fill: '#f0ead8' }}
            d="M410.292,224.045H91.008c-5.891,0-10.672-4.773-10.672-10.671c0-5.891,4.781-10.664,10.672-10.664h319.284c5.891,0,10.672,4.773,10.672,10.664C420.964,219.271,416.182,224.045,410.292,224.045z"
          />
          <path
            style={{ fill: '#c4983a' }}
            d="M410.635,0c-17.625,0-31.999,14.358-31.999,31.998c0,17.648,14.374,31.999,31.999,31.999c17.655,0,31.998-14.351,31.998-31.999C442.634,14.358,428.291,0,410.635,0z"
          />
        </svg>
      </div>
    </>
  );
};
